// Centralized API URL constants for asset management

import { environment } from '@environments/environment';

export const API_BASE = environment.apiUrl;
export const API_BASE_OLD = 'https://dntiop-vendorapidev.cbre.com/api';

export const ASSET_MANAGEMENT_API = {
  ALL_ASSET_CARD_DETAILS: `${API_BASE}/asset-management/assets/all-asset-card-details`,
  EMPLOYEE_ASSET_ACCESSORIES_INFO: `${API_BASE}/asset-management/employee-asset-accessories-info`,
  EMPLOYEE_ASSET_ACCESSORIES: `${API_BASE}/asset-management/employee-asset-accessories`,
  EMPLOYEE_BASIC_INFO: `${API_BASE}/asset-management/employee-basic-info`,
  DAMAGE_ANALYTICS: `${API_BASE}/asset-management/damage-analytics`,
  OFFBOARDING_EMPLOYEE_DETAILS: `${API_BASE}/asset-management/offboarding-employee-details`,
  ONBOARDING_EMPLOYEE_DETAILS: `${API_BASE}/asset-management/onboarding-employee-details`,
  VENDOR_STATS_CARD: `${API_BASE}/asset-management/vendor/stats-card`,
  VENDOR_CARD_SUMMARY: `${API_BASE}/asset-management/vendor/card-summary`,
  ASSETS_CARD_SUMMARY: `${API_BASE}/asset-management/assets/card-summary`,
  GET_RESOURCE_PROFILE_PAGE_INFO: `${API_BASE}/asset-management/getResourceProfilePageInfo`,
  UPDATE_RETURN_STATUS: `${API_BASE}/asset-management/update-return-status`,
  CREATE_OFFBOARDING_REQUEST: `${API_BASE}/asset-management/createOffboardingRequest`,
  GET_STATUS_DROPDOWN: `${API_BASE}/asset-management/getStatusDropdown`,
  GET_ALL_ITEMS: `${API_BASE}/asset-management/inventory/items`,
  GET_ALL_ISSUE_ITEMS: `${API_BASE}/asset-management/inventory/new-issue-items`,
  ITEM_DETAILS: `${API_BASE}/asset-management/inventory/item-details`,
  ISSUED_ORDER_SUMMARY: `${API_BASE}/asset-management/inventory/issued-order-summary`,
  PROCURED_SUMMARY: `${API_BASE}/asset-management/inventory/procurement-summary`,
  ITEM_HISTORY: `${API_BASE}/asset-management/inventory/item-history`,
  SAVE_PROCURED_ORDER: `${API_BASE}/asset-management/inventory/saveProcuredOrder`,
  PROCURED_ITEMS: `${API_BASE}/asset-management/inventory/procured-items`,
  UPDATE_ORDER_ATTACHMENT: `${API_BASE}/asset-management/inventory/update-orders-attachment-url`,
  VIEW_INVOICE: `${API_BASE}/asset-management/inventory/invoice-preview-image`,
  UPDATE_ISSUE_ORDER: `${API_BASE}/asset-management/inventory/item-issue`,
  UPDATE_DELIVERY_STATUS: `${API_BASE}/asset-management/inventory/update-delivery-status`,
  SEARCH_EMPLOYEES_BY_EMAIL: `${API_BASE}/employee-management/employees-by-email`,
  CREATE_AND_RETRIEVE_COMMENTS: `${API_BASE}/asset-management/createAndRetrieveComments`,
  CANCEL_ASSET: `${API_BASE}/asset-management/cancel-asset`,
  UPDATE_COMMENTS: `${API_BASE}/asset-management/employee-asset-accessories/comments`,
  LOCATION_EMAIL_NOTIFICATIONS: `${API_BASE}/asset-management/location/getEmailNotifications`,
  GET_ASSET_REQUESTS: `${API_BASE}/asset-management/get-asset-requests`,
  CREATE_ASSET_REQUEST: `${API_BASE}/asset-management/create-request`,
  UPDATE_ASSET_REQUEST: `${API_BASE}/asset-management/update-asset-request`,
  ACCESSORIES_API_URL_AFTER_UPDATE: `${API_BASE}/asset-management/utilities/getAllAccessories`,
  GET_ACCESSORIES_DETAILS: `${API_BASE}/asset-management/getAccessoriesDetails`,
  CREATED_ASSET_REPLACE: `${API_BASE}/asset-management/assets/card`,
  PRODUCT_ITEMS: `${API_BASE}/asset-management/utilities/product-items`,
  PRODUCT_SIZES: `${API_BASE}/asset-management/utilities/product-sizes`,
  GROUPED_BY_CATEGORY: `${API_BASE}/asset-management/inventory/grouped-by-category`,
  BULK_ISSUE_UPLOAD: `${API_BASE}/asset-management/utilities/bulk-upload-issued-items`,
  BULK_UPLOAD_PROCURED_ITEMS: `${API_BASE}/asset-management/utilities/bulk-upload-procured-items`,
};